import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cd767bd0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd767bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd767bd0')) {
      api.createRecord('cd767bd0', component.options)
    } else {
      api.reload('cd767bd0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cd767bd0&scoped=true", function () {
      api.rerender('cd767bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/postCustomerManage/index.vue"
export default component.exports